import React, { useState, useEffect } from "react";
import { Button, Form, Input, Spin, notification, message } from "antd";
import axios from "axios";
import styled from "styled-components";
import EventClosed from "./components/EventClosed";
import ShowQRCode from "./components/ShowQRCode";
import Message from './components/Message';

const StyledSpin = styled(Spin)`
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
`;

const Logo = styled.img`
  height: auto;
  width: 160px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const StyledDiv = styled.div`

`;

const BottomDiv = styled.div`
  p {
    text-align: center;
  }
`;
const StyleFormWrapper = styled("div")`
  .ant-input{
    box-shadow: 2px 2px 13px 3px #958d8d14;
    border: 1px solid #e9ecef;
    border-radius: 5px;
    opacity: 1;
    height: 40px;
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #0000006b;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #0000006b;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #0000006b;
}
  }
  .ant-btn-primary {
   height:40px;
   font-size: 16px;
   font-weight: 500;
   border-radius: 5px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
`

const StyledEditNumberButton = styled(Button)`

&.ant-btn-primary {
  color: #fff;
  border-color: #45494c !important;
  background: #45494c !important;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
}
margin-top:10px;
`
const Container = styled("div")`
padding:20px 0;
  background-image: url("${(props) => props.backgroundImage}");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`

const DisplayContent = (props) => {
  const { showVerification, setShowVerfication, loading, setLoading, root } =
    props;
  const [formData, setFromData] = useState(null);
  const [luckyDraw, setLuckyDraw] = useState(null);
  const [showCoupon, setShowCoupon] = useState(false);
  const [qrText, setQrText] = useState("");
  const [isRedeemed, setIsRedeemed] = useState(false);
  const [isDoorPrize, setIsDoorPrize] = useState(false);
  const [isResentCode, setIsResentCode] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");


  const [form] = Form.useForm();

  const handleVerification = (values) => {
    const { code, phone, fullName } = values;
    let bodyData = new FormData();
    const firstName = fullName.split(" ")[0]?.trim();
    const lastName = fullName.split(" ").slice(1).join(" ")?.trim();
    bodyData.append("FirstName", firstName);
    bodyData.append("LastName", lastName);
    bodyData.append("Phone", phone);
    bodyData.append("Email", `${firstName}@${lastName}.com`);
    bodyData.append("EventId", root && root.eventID);
    bodyData.append("EventTypeId", root && root.eventTypeId);
    bodyData.append("verificationCode", code);


    setLoading(true);
    axios(
      `/api/DoorPrize/PostVerificationCode`,
      {
        method: "POST",
        data: bodyData,
      }
    )
      .then((response) => {
        setLoading(false);

        if (root.eventTypeId === 1) {
          setFirstName(response?.data?.firstName)
          setLastName(response?.data?.lastName)
          setLuckyDraw(response?.data.luckyDraw)
          setIsDoorPrize(true)
        } else {
          setFirstName(response?.data?.firstName)
          setLastName(response?.data?.lastName)
          setQrText(response?.data?.eventPlayerDetails?.guid)
          setIsRedeemed(response?.data?.eventPlayerDetails?.isReedemed)
          setShowCoupon(true)
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.status === 409) {
          if (root.eventTypeId === 1) {
            setLuckyDraw(err?.response?.data?.luckyDraw)
            setIsDoorPrize(true)
          } else {
            setQrText(err?.response.data.guid)
            setIsRedeemed(err?.response?.data?.isRedeemed)
            setShowCoupon(true)
          }
          setFirstName(err?.response?.data?.firstName)
          setLastName(err?.response?.data?.lastName)
        }
        else if (err.response && err.response.status === 400) {
          const errorMessage = err?.response?.data
          let displayMessage = ""
          if (errorMessage.includes("No pending verifications")) {
            displayMessage = "No pending verifications for this number!";
            setIsResentCode(true);
            setShowVerfication(false);
          } else {
            switch (errorMessage) {
              case "Verification code is incorrect":
                displayMessage = "Please Enter Valid Code!"
                break;
              default:
                displayMessage = err?.response?.data
            }
          }
          message.error({
            content: displayMessage,
            duration: 4,
            style: {
              marginTop: '20px',
            },
          });
        } else {
          message.error({
            content: "Sorry! Can't Process your request at the moment",
            duration: 4,
            style: {
              marginTop: '20px',
            },
          });
        }
      });
  };

  const handleFormSubmit = (values) => {
    setFromData(values);
    const { phone } = values;
    setLoading(true);
    setIsResentCode(false);
    axios(`/api/DoorPrize/VerifyPhone`, {
      method: "POST",
      params: { phone: phone, eventId: root.eventID },
    })
      .then((response) => {
        const { data } = response;
        setLoading(false);
        setShowVerfication(true);
        message.success({
          content: 'Enter verification code sent to you!',
          duration: 4,
          style: {
            marginTop: '20px',
          },
        });

      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.status === 400) {
          const errorMessage = err?.response?.data
          message.error({
            content: (errorMessage === "Phone number not provisioned with any carrier" || errorMessage === "Phone number is invalid") ? "Please Enter Valid Phone Number!" : err?.response?.data,
            duration: 4,
            style: {
              marginTop: '20px',
            },
          });
        } else {
          message.error({
            content: "Sorry! Can't Process your request at the moment",
            duration: 4,
            style: {
              marginTop: '20px',
            },
          });
        }
      });
  };

  const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  };

  const images = importAll(
    require.context("../../images", false, /\.(png|jpe?g|svg)$/)
  );
  const handleChangeNumber = () => {
    setShowVerfication(false);
    form.setFieldsValue({ code: '' })
  }
  const validatePhone = (rule, value, callback) => {
    const regex = /^([a-zA-Zà-úÀ-Ú]{2,})+\s+([.a-zA-Zà-úÀ-Ú\s]{2,})+$/
    if (value) {
      if (regex.test(value?.trim())) {
        callback()
      } else {
        callback("Please enter your first name and last name!")
      }
    } else {
      callback();
    }
  };
  return (

    <Container className="outside-container" backgroundImage={root.backgroundImage}>
      <StyledDiv className="main-container">
        <StyleFormWrapper className="form-wrapper">
          <Logo src={images["logo.png"]} />
          {(!showCoupon && !isDoorPrize) &&
            <Form
              initialValues={{
                firstName: formData && formData.firstName,
                lastName: formData && formData.lastName,
                phone: formData && formData.phone,
                email: formData && formData.email,
              }}
              layout="vertical"
              onFinish={showVerification ? handleVerification : handleFormSubmit}
              requiredMark={false}
              form={form}
            >
              <Form.Item

                name="fullName"
                rules={[
                  {
                    required: true,
                    message: "Please enter your full name!",
                  },
                  {
                    pattern: /^([^0-9]*)$/,
                    message: "Please enter valid name",
                  },
                  {
                    validator: validatePhone,
                    validateTrigger: "onFinish"
                  }
                ]}
              >

                <Input placeholder="Full Name" readOnly={showVerification} />
              </Form.Item>

              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Please enter your phone number!",
                  },
                  { max: 10, message: "Phone number must be of 10 digits." },
                  { min: 10, message: "" },
                  {
                    pattern: /^[0-9]*$/,
                    message: "Please enter a valid phone number!",
                  },
                ]}
              >
                <Input placeholder="Phone Number" type="number" readOnly={showVerification} />
              </Form.Item >

              {showVerification && <Form.Item
                name="code"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter a verification code!",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter Your Verfication Code" />
              </Form.Item>}

              <Form.Item >
                <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                  <Button
                    className="submitBtn"
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    style={{ minWidth: 150 }}
                  >
                    {showVerification ? "Verify" : isResentCode ? "Resend Code" : "Submit"}
                  </Button>
                </div>
                {showVerification && <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                  <StyledEditNumberButton onClick={handleChangeNumber} className="submitBtn" type="primary">Change Number</StyledEditNumberButton>
                </div>}
              </Form.Item>


            </Form >}
          {isDoorPrize && <Message root={root} luckyDraw={luckyDraw} firstName={firstName} lastName={lastName} />}
          {
            showCoupon && (
              <ShowQRCode qrText={qrText} isRedeemed={isRedeemed} root={root} firstName={firstName} lastName={lastName} />
            )
          }
          <BottomDiv>
            <p style={{ marginBottom: 0 }}>We shall never share your data</p>
            <p >
              <a href="/privacy" target="_blank">
                Customer Privacy
              </a>
            </p>
          </BottomDiv>
        </StyleFormWrapper >

      </StyledDiv >
    </Container>
  );
};

const Tickets = () => {
  const [showVerification, setShowVerfication] = useState(false);
  const [root, setRoot] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const api = "/api/Event/GetEvent";
    const request = {
      method: "GET",
    };
    axios(api, request)
      .then((response) => {
        const { data } = response;
        setRoot(data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);


  if (!root) {
    return <StyledSpin size="large" />;
  } else if (root.isActive) {
    return (
      <DisplayContent
        showVerification={showVerification}
        setShowVerfication={setShowVerfication}
        loading={loading}
        setLoading={setLoading}
        root={root}
      />
    );
  } else {
    return <EventClosed root={root} />;
  }
};

export default Tickets;
